import React from 'react';
import { RightOutlined, DownOutlined } from '@ant-design/icons';
import { ViewModeState } from '../../constants';
import './SwitchSummaryViewMode.scss';

export const SwitchSummaryViewMode = ({ collapsed, onChange, disabled, className = '' }) => {
    const isOpen = !collapsed;

    return (
        <button
            type="button"
            onClick={onChange}
            disabled={disabled}
            className={`switch-summary-view-mode ${className}`}
        >
            {isOpen ? <DownOutlined /> : <RightOutlined />}
        </button>
    );
};
